var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isDesktop)?_c('prz-desktop',_vm._b({attrs:{"profile":_vm.socialProfile}},'prz-desktop',_vm.$props,false)):_c('prz-mobile',_vm._b({attrs:{"profile":_vm.socialProfile}},'prz-mobile',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }